export default "__VITE_PUBLIC_ASSET__ec06e4b7__"